import { env } from './env';

function getPalmyouUrl() {
  let palmyouUrl;
  if (env) {
    palmyouUrl = 'http://test-s2b.palmyou.com/ah/oauth/authorize?response_type=code&client_id=JvPC8GYDk0jByKMw&redirect_uri=https://testapi.666visa.cn/www/open/palmyou_auth_callback';
  } else {
    palmyouUrl = 'http://s2b.palmyou.cn/ah/oauth/authorize?response_type=code&client_id=JvPC8GYDk0jByKMw&redirect_uri=https://api.666visa.cn/www/open/palmyou_auth_callback';
  }
  return palmyouUrl;
}


export const palmyouUrl = getPalmyouUrl();



// WEBPACK FOOTER //
// ./src/libs/palmyou-url.js